var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Card, CardTitle, Divider, getTestId, Input, isValidObject, LILAC_200, LILAC_300, WHITE, Badge, InView } from '@airtel/air-design-system';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FlatList, Pressable, View } from 'react-native';
import { CalloutWidget } from '../callout-widget';
import { CardTitleWidget } from '../card-title-widget';
import { OrderSummaryCardWidget } from '../order-summary-card-widget';
import { SelectionListWidgetComponent } from '../selection-list-widget/SelectionListWidget';
import { OfferContextualStripWidget } from '../offer-contextual-strip-widget';
import { SectionTitleWidget } from '../section-title-widget';
import { getOfferListWidgetStyles } from './OfferListWidgetStyles';
import { getSearchBar, getSuggestionList, getSearchValue, getSearchBarWithMutliKey } from './OfferListWidgetUtils';
export var OfferListWidgetComponent = props => {
  var id = props.id,
    data = props.data,
    _props$maxItemsToShow = props.maxItemsToShow,
    maxItemsToShow = _props$maxItemsToShow === void 0 ? 0 : _props$maxItemsToShow,
    _props$buttonProps = props.buttonProps,
    buttonProps = _props$buttonProps === void 0 ? {} : _props$buttonProps,
    style = props.style,
    _props$showDivider = props.showDivider,
    showDivider = _props$showDivider === void 0 ? true : _props$showDivider,
    _props$borderColor = props.borderColor,
    borderColor = _props$borderColor === void 0 ? WHITE : _props$borderColor,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? LILAC_200 : _props$backgroundColo,
    _props$showShadow = props.showShadow,
    showShadow = _props$showShadow === void 0 ? true : _props$showShadow,
    onUserAction = props.onUserAction,
    _props$enableSearchBa = props.enableSearchBar,
    enableSearchBar = _props$enableSearchBa === void 0 ? false : _props$enableSearchBa,
    searchBarPlaceHolder = props.searchBarPlaceHolder,
    searchKey = props.searchKey,
    searchBarStyle = props.searchBarStyle,
    searchBarFocusMetaData = props.searchBarFocusMetaData,
    searchBarImpressionMetaData = props.searchBarImpressionMetaData,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'OfferListWidget' : _props$testID,
    calloutProps = props.calloutProps,
    cardTitleProps = props.cardTitleProps,
    onHeaderImpressionActions = props.onHeaderImpressionActions,
    _props$isCurrentItemV = props.isCurrentItemVisible,
    isCurrentItemVisible = _props$isCurrentItemV === void 0 ? true : _props$isCurrentItemV,
    searchBarBlurMetaData = props.searchBarBlurMetaData,
    _props$enableSearchSu = props.enableSearchSuggestion,
    enableSearchSuggestion = _props$enableSearchSu === void 0 ? false : _props$enableSearchSu,
    _props$searchSuggesti = props.searchSuggestionData,
    searchSuggestionData = _props$searchSuggesti === void 0 ? [] : _props$searchSuggesti,
    suggestionVisibleMetaData = props.suggestionVisibleMetaData,
    suggestionStyle = props.suggestionStyle,
    suggestionRegex = props.suggestionRegex,
    titleForList = props.titleForList,
    onValidInputMetaData = props.onValidInputMetaData,
    onInValidInputMetaData = props.onInValidInputMetaData,
    _props$enableAppendSe = props.enableAppendSearchSuggestion,
    enableAppendSearchSuggestion = _props$enableAppendSe === void 0 ? false : _props$enableAppendSe,
    searchKeys = props.searchKeys;
  var offerListWidgetStyles = getOfferListWidgetStyles(props);
  var _useState = useState(data),
    list = _useState[0],
    setListData = _useState[1];
  var _useState2 = useState(false),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState(''),
    searchItem = _useState3[0],
    setSearchItem = _useState3[1];
  var _useState4 = useState(false),
    isSuggetionValid = _useState4[0],
    setSuggetionValid = _useState4[1];
  var _useState5 = useState(searchSuggestionData),
    suggetionList = _useState5[0],
    setSuggetionList = _useState5[1];
  var setOfVisitedIds = useRef(new Set());
  var _useState6 = useState(),
    selectedItemList = _useState6[0],
    setSelectedItemList = _useState6[1];
  var viewMoreButtonTitle = isExpanded ? buttonProps.expandedTitle : buttonProps.title;
  var _ref = buttonProps || {},
    _ref$showButtonDivide = _ref.showButtonDivider,
    showButtonDivider = _ref$showButtonDivide === void 0 ? true : _ref$showButtonDivide;
  useEffect(() => {
    transformDataWithMaxItemsToShow();
  }, [isExpanded, data]);
  useEffect(() => {
    setSelectedItemList(data);
  }, [data]);
  var transformDataWithMaxItemsToShow = () => {
    if (data) {
      var newData = [...data];
      if (!isExpanded && maxItemsToShow > 0) {
        newData = [...newData.slice(0, maxItemsToShow)];
      } else {
        newData = [...data];
      }
      setListData(newData);
    }
  };
  var searchBarOnChangeHandler = searchValue => {
    setSearchItem(searchValue);
    if (searchKeys) {
      var matches = getSearchBarWithMutliKey(selectedItemList, searchKeys, searchValue);
      setListData(matches);
    } else {
      var _matches = getSearchBar(selectedItemList, searchKey, searchValue);
      setListData(_matches);
    }
    if (suggestionRegex) {
      var regex = new RegExp(suggestionRegex);
      setSuggetionValid(regex.test(searchValue));
      var filteredSuggestion = getSuggestionList(searchSuggestionData, suggestionRegex, searchValue);
      setSuggetionList(filteredSuggestion);
    }
  };
  var onOfferListPress = pressedItemId => {
    if (list === null || list === void 0 ? void 0 : list.some(item => {
      var _a, _b;
      return ((_b = (_a = item === null || item === void 0 ? void 0 : item.selectionListProps) === null || _a === void 0 ? void 0 : _a.linkListItemProps) === null || _b === void 0 ? void 0 : _b.actionType) !== 'radio';
    })) {
      return;
    }
    var updatedList = list.map(item => {
      var _a;
      if (isValidObject(item === null || item === void 0 ? void 0 : item.selectionListProps)) {
        if (((_a = item === null || item === void 0 ? void 0 : item.selectionListProps) === null || _a === void 0 ? void 0 : _a.id) === pressedItemId) {
          item.selectionListProps.isSelected = true;
        } else {
          item.selectionListProps.isSelected = false;
          item.selectionListProps.otpProps = {};
        }
      }
      return item;
    });
    var updatedSelectedList = selectedItemList === null || selectedItemList === void 0 ? void 0 : selectedItemList.map(item => {
      var _a;
      if (isValidObject(item === null || item === void 0 ? void 0 : item.selectionListProps)) {
        if (((_a = item === null || item === void 0 ? void 0 : item.selectionListProps) === null || _a === void 0 ? void 0 : _a.id) === pressedItemId) {
          item.selectionListProps.isSelected = true;
        } else {
          item.selectionListProps.isSelected = false;
          item.selectionListProps.otpProps = {};
        }
      }
      return item;
    });
    setListData(updatedList);
    setSelectedItemList(updatedSelectedList);
  };
  var itemWrapper = item => {
    var _a, _b;
    var singleItem = item;
    var orderSummaryCardProps = (singleItem === null || singleItem === void 0 ? void 0 : singleItem.orderSummaryCardProps) || {};
    var cardTitleProps = (singleItem === null || singleItem === void 0 ? void 0 : singleItem.cardTitleProps) || {};
    var offerStripProps = (singleItem === null || singleItem === void 0 ? void 0 : singleItem.offerStripProps) || {};
    var selectionListProps = singleItem === null || singleItem === void 0 ? void 0 : singleItem.selectionListProps;
    var onPressMetaData = (_a = singleItem === null || singleItem === void 0 ? void 0 : singleItem.cardTitleProps) === null || _a === void 0 ? void 0 : _a.onPressMetaData;
    var cardTitleStyle = (_b = singleItem === null || singleItem === void 0 ? void 0 : singleItem.cardTitleProps) === null || _b === void 0 ? void 0 : _b.style;
    var offerListStyle = offerStripProps === null || offerStripProps === void 0 ? void 0 : offerStripProps.style;
    var showItemDivider = (singleItem === null || singleItem === void 0 ? void 0 : singleItem.showItemDivider) || false;
    var containerStyle = (singleItem === null || singleItem === void 0 ? void 0 : singleItem.style) || {};
    return _jsxs(View, Object.assign({
      style: [offerListWidgetStyles.listItemWrapper, showItemDivider && offerListWidgetStyles.veriticalMargin, containerStyle]
    }, {
      children: [isValidObject(orderSummaryCardProps) && _jsx(OrderSummaryCardWidget, Object.assign({}, orderSummaryCardProps, getTestId(testID, 'orderSummaryCardWidget'), {
        onUserAction: onUserAction,
        style: [offerListWidgetStyles.amountPayable, orderSummaryCardProps === null || orderSummaryCardProps === void 0 ? void 0 : orderSummaryCardProps.style]
      })), isValidObject(cardTitleProps) && _jsx(Pressable, Object.assign({
        onPress: () => {
          onPressMetaData && onUserAction(Object.assign({
            id
          }, onPressMetaData), cardTitleProps);
        }
      }, {
        children: _jsx(CardTitle, Object.assign({}, cardTitleProps, getTestId(testID, 'cardTitle'), {
          style: [offerListWidgetStyles.cardTitle, cardTitleStyle]
        }))
      })), isValidObject(offerStripProps) && _jsx(OfferContextualStripWidget, Object.assign({}, item === null || item === void 0 ? void 0 : item.offerStripProps, {
        style: [offerListWidgetStyles.offerList, offerListStyle]
      }, getTestId(testID, 'offerStrip'), {
        onUserAction: onUserAction
      })), isValidObject(selectionListProps) && _jsx(SelectionListWidgetComponent, Object.assign({
        isCurrentItemVisible: isCurrentItemVisible
      }, selectionListProps, getTestId(testID, 'selectionListWidget'), {
        onLinkListItemPress: onOfferListPress,
        onUserAction: onUserAction
      }))]
    }));
  };
  useEffect(() => {
    if (enableSearchBar) {
      searchBarImpressionMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, searchBarImpressionMetaData), {
        searchBarPlaceHolder,
        searchKey,
        searchItem
      }));
    }
  }, [enableSearchBar]);
  var onViewableItemsChanged = useCallback(info => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _loop = function _loop(i) {
      var sendImpression = !((_b = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _b === void 0 ? void 0 : _b.has((_c = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _c === void 0 ? void 0 : _c.index));
      if (sendImpression && ((_e = (_d = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _d === void 0 ? void 0 : _d[i]) === null || _e === void 0 ? void 0 : _e.index) != null) {
        (_f = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _f === void 0 ? void 0 : _f.add((_g = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _g === void 0 ? void 0 : _g.index);
        (_k = (_j = (_h = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _h === void 0 ? void 0 : _h[i].item) === null || _j === void 0 ? void 0 : _j.onItemsImpressionMetaData) === null || _k === void 0 ? void 0 : _k.map(data => {
          var _a;
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, data), (_a = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _a === void 0 ? void 0 : _a.item);
        });
      }
    };
    for (var i = 0; i < ((_a = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _a === void 0 ? void 0 : _a.length); i++) {
      _loop(i);
    }
  }, []);
  var ItemSeparator = leadingItem => {
    var _ref2 = leadingItem || {},
      _ref2$showItemDivider = _ref2.showItemDivider,
      showItemDivider = _ref2$showItemDivider === void 0 ? false : _ref2$showItemDivider;
    return showDivider || showItemDivider ? _jsx(Divider, {
      color: LILAC_300,
      shadowColor: WHITE,
      height: 2
    }) : null;
  };
  var suggestionItem = _ref3 => {
    var item = _ref3.item,
      index = _ref3.index;
    var _a = item || {},
      label = _a.label,
      onPressMetaData = _a.onPressMetaData,
      restItemProps = __rest(_a, ["label", "onPressMetaData"]);
    return _jsx(InView, Object.assign({
      triggerOnce: true,
      onChange: inView => {
        inView && suggestionVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, suggestionVisibleMetaData), Object.assign({
          index
        }, item)));
      }
    }, {
      children: _jsx(Badge, Object.assign({
        style: offerListWidgetStyles.suggestionRightSpace,
        size: "md",
        label: label,
        onPress: () => {
          if (enableAppendSearchSuggestion && label) {
            var withSuggestion = getSearchValue(label, searchItem, suggestionRegex);
            searchBarOnChangeHandler(withSuggestion);
          }
          onPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onPressMetaData), Object.assign({
            index
          }, item)));
        },
        type: 'single'
      }, restItemProps, getTestId(testID + '_suggestionItem', index.toString())), "suggestion_item_" + index)
    }));
  };
  var keyExtractor = item => "offer_list_item_" + (item === null || item === void 0 ? void 0 : item.id);
  return _jsxs(View, {
    children: [enableSearchBar && _jsx(Input, Object.assign({
      style: searchBarStyle,
      placeholder: searchBarPlaceHolder,
      onFocus: () => {
        searchBarFocusMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, searchBarFocusMetaData), props));
      },
      onChangeText: searchBarOnChangeHandler,
      value: searchItem,
      onBlur: () => {
        searchBarBlurMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, searchBarBlurMetaData), props));
      },
      onValidInput: value => {
        onValidInputMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onValidInputMetaData), {
          value
        }));
      },
      onInValidInput: value => {
        onInValidInputMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onInValidInputMetaData), {
          value
        }));
      }
    }, props === null || props === void 0 ? void 0 : props.otherInputProps)), enableSearchSuggestion && (suggestionRegex ? isSuggetionValid : true) && isValidObject(suggetionList) && _jsx(FlatList, Object.assign({}, getTestId(testID, 'SuggestionFlatList'), {
      style: suggestionStyle,
      showsHorizontalScrollIndicator: false,
      showsVerticalScrollIndicator: false,
      data: suggetionList,
      renderItem: suggestionItem,
      horizontal: true
    })), (list === null || list === void 0 ? void 0 : list.length) > 0 && _jsxs(Card, Object.assign({
      noPadding: true,
      borderColor: borderColor,
      backgroundColor: backgroundColor,
      showShadow: showShadow,
      style: style
    }, getTestId(testID), {
      children: [_jsx(FlatList, Object.assign({}, getTestId(testID, 'FlatList'), {
        data: list,
        keyboardShouldPersistTaps: "handled",
        keyExtractor: keyExtractor,
        renderItem: _ref4 => {
          var item = _ref4.item;
          return itemWrapper(item);
        },
        ItemSeparatorComponent: _ref5 => {
          var leadingItem = _ref5.leadingItem;
          return ItemSeparator(leadingItem);
        },
        onViewableItemsChanged: onViewableItemsChanged,
        ListHeaderComponent: _jsxs(_Fragment, {
          children: [onHeaderImpressionActions && onHeaderImpressionActions.length > 0 && (onHeaderImpressionActions === null || onHeaderImpressionActions === void 0 ? void 0 : onHeaderImpressionActions.map(data => {
            !setOfVisitedIds.current.has('header_impression') && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, data), {
              calloutProps,
              cardTitleProps
            }));
            setOfVisitedIds.current.add('header_impression');
          })), isValidObject(calloutProps) && _jsx(View, Object.assign({
            style: offerListWidgetStyles.headItemWrapper
          }, {
            children: _jsx(CalloutWidget, Object.assign({}, calloutProps, getTestId(testID, 'callout'), {
              onUserAction: onUserAction,
              style: [offerListWidgetStyles.callout, calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.style]
            }))
          })), isValidObject(cardTitleProps) && _jsx(CardTitleWidget, Object.assign({}, cardTitleProps, getTestId(testID, 'cardTitle'), {
            onUserAction: onUserAction,
            style: [offerListWidgetStyles.headItemWrapper, cardTitleProps === null || cardTitleProps === void 0 ? void 0 : cardTitleProps.style]
          })), isValidObject(titleForList) && _jsx(SectionTitleWidget, Object.assign({}, titleForList, getTestId(testID, 'titleForList'), {
            onUserAction: onUserAction,
            style: [offerListWidgetStyles.headItemWrapper, titleForList === null || titleForList === void 0 ? void 0 : titleForList.style]
          }))]
        })
      })), isValidObject(buttonProps) && _jsxs(View, Object.assign({
        style: offerListWidgetStyles.expandSection
      }, {
        children: [showDivider || showButtonDivider ? _jsx(Divider, {
          color: LILAC_300,
          shadowColor: WHITE,
          height: 2
        }) : null, _jsx(Button, Object.assign({
          title: viewMoreButtonTitle,
          iconPosition: "right",
          iconName: isExpanded ? buttonProps.expandedIconName : buttonProps.iconName,
          buttonType: "tertiary",
          version: "variable-width"
        }, getTestId(testID, 'button'), {
          onPress: () => {
            setIsExpanded(!isExpanded);
            (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, buttonProps.onPressMetaData), Object.assign(Object.assign({}, buttonProps), {
              buttonTitle: viewMoreButtonTitle
            })));
          },
          style: offerListWidgetStyles.expandCta
        }, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.accessibilityProps))]
      }))]
    }))]
  });
};
OfferListWidgetComponent.genericRendererKey = 'AirOfferListWidget';